import * as ActionTypes from '../ActionTypes';

const initialState = {
    isLoading: false,
    error: false,
    errorMessage: "",
    minDojYear: "",
};


export const WorkSpaceDojReducer = function (state = initialState, action) {
    switch (action.type) {

        case ActionTypes.GET_WORKSPACEDOJ_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
            };
        case ActionTypes.GET_WORKSPACEDOJ_SUCCESS:
            return {
                ...state,
                isLoading: false,
                successMessage: action.payload?.message,
                minDojYear: action.payload?.data?.data?.[0]?.workspace_creation || ""
            };
        case ActionTypes.GET_WORKSPACEDOJ_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        default:
            return state;
    }
}
export default WorkSpaceDojReducer;